module.exports = __webpack_public_path__ + "static/media/projects_top_min.7faea516.jpg";